var NO_ADHESION_OVERLAP = 'no-adhesion-overlap';
var $body = $('body');

$('.modal-drawer.no-adhesion-overlap').on('shown.bs.modal', function () {
    if(!$body.hasClass(NO_ADHESION_OVERLAP)) {
        $body.addClass(NO_ADHESION_OVERLAP);
    }
});

$('.modal-drawer.no-adhesion-overlap').on('hidden.bs.modal', function () {
    if($body.hasClass(NO_ADHESION_OVERLAP)) {
        $body.removeClass(NO_ADHESION_OVERLAP);
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/drawer/no-adhesion-overlap.js
// module id = 130
// module chunks = 0 1 2 9 16